// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"987074ef","58":"f3b8bb48","112":"e2824943","123":"bf223f36","295":"32f5c207","402":"2fbaa885","413":"9b175a3b","483":"c192df75","501":"55ebd67a","520":"9e1758a5","548":"cacc31b1","761":"6669c92c","812":"87caffcf","858":"47fb1393"}[chunkId] + ".chunk.js";
};